import { render } from "./QuickpayPDFViewer.vue?vue&type=template&id=891adf82&scoped=true"
import script from "./QuickpayPDFViewer.vue?vue&type=script&lang=js"
export * from "./QuickpayPDFViewer.vue?vue&type=script&lang=js"

import "./QuickpayPDFViewer.vue?vue&type=style&index=0&id=891adf82&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-891adf82"]])

export default __exports__